import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../components/States/AppContext";

// styles
import { ImgHr } from "./HrButton.elements";


// images
import hrDefault from "../../img/numeric/hr/hr-default.gif";
import hrAlarm from "../../img/numeric/hr/hr-alarm.gif";
import hrReboot from "../../img/numeric/hr/hr-reboot.gif";
import hrRelearn from "../../img/numeric/hr/hr-relearn.png";



const HrButton = () => {
  const { state, setState } = useContext(AppContext);

  return (
    <>
      <Link
        to={
          state.ecg === false ? "/settings/changenumeric" : "/settings/ecgsetup"
        }
      >
        {state.ecg === false ? (
          <ImgHr src={hrDefault} style={{ opacity: "0" }} />
        ) : state.reboot === true ? (
          <ImgHr src={hrReboot} />
        ) : state.relearn ? (
          <ImgHr src={hrRelearn} />
        ) : state.initiateAlarms === true  ? (
          <ImgHr src={hrAlarm} />
        ) : (
          <ImgHr src={hrDefault} />
        )}
      </Link>
    </>
  );
};

export default HrButton;
